import Icon from '../components/Icon';

const ThumbsUp = Icon(
  'thumbs-up',
  <>
    <path
      fillRule="evenodd"
      d="M11.83 1.545a.75.75 0 0 0-.925.344L7.054 9H3a1.5 1.5 0 0 0-1.5 1.5v8.25a1.5 1.5 0 0 0 1.5 1.5h14.241a3.75 3.75 0 0 0 3.663-2.947l1.561-7.123a2.75 2.75 0 0 0-2.686-3.339h-4.587V6.1a4.75 4.75 0 0 0-3.065-4.441zM6.748 10.5v8.25H3V10.5zm1.502 8.25h8.99a2.25 2.25 0 0 0 2.198-1.768L21 9.859a1.25 1.25 0 0 0-1.22-1.518h-5.338a.75.75 0 0 1-.75-.75V6.1a3.25 3.25 0 0 0-1.79-2.903L8.25 9.94z"
      clipRule="evenodd"
    />
  </>
);

export default ThumbsUp;
